import React, { useState, useEffect } from "react";
import { Modal, Button, Loader } from "semantic-ui-react";
import { producaov2 as api, local } from "../../../../services/apis";
import { Container } from "./styled";
import { formatValue } from "../../../../utils/Utils";
import swal from "sweetalert";

export default function ModalCharge({ aluno, charge, handleClose }) {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)

  const status = {
    pending: 'pendente',
    paid: "pago",
    canceled: "cancelado",
    processing: "processando",
    failed: "falhou",
  }

  const handleSubmit = async (chargeId) => {
    setLoading(true)

    await api.post('/pagarme/charge/reply', { chargeId })
      .then(res => {
        setResponse(res.data)
      }).catch(err => {
        console.log(err)
        swal("Erro", "Erro ao retentar essa cobrança", "error");
      })

    setLoading(false)
  }


  const handleClear = () => {
    setResponse(null)
    handleClose()
  }

  if (!charge || !aluno) return <></>

  const getDate = (date) => new Date(date).toLocaleString()

  return (
    <Modal
      size={"small"}
      open={!!charge}
      onClose={() => handleClear()}
    >
      <Modal.Header>Tem certeza que deseja retentar essa cobrança manualmente?</Modal.Header>
      <Modal.Content>

        <Container>
          {loading ? <Loader active /> : (
            <>
              <p>Aluno: <strong>{aluno.name}</strong></p>
              <p>Valor da cobrança: R$<strong>{formatValue(charge.amount)}</strong></p>
              <p>Última tentativa: <strong>{getDate(charge.updated_at)}</strong></p>
              <a href={`https://dash.pagar.me/merch_GJEQOK9ilt7lMP1b/acc_plNnPkWTwXFY4M3Z/charges/${charge.id}`}
                target='_blank'>Abrir cobrança na pagarme</a>
            </>
          )}

          {(!loading && response) && (
            <div>
              <p>{status[response.status] || response.status}</p>
              <span>{response?.message}</span>
            </div>
          )}


        </Container>

      </Modal.Content>
      <Modal.Actions>
        <Button type="button" positive onClick={() => handleSubmit(charge.id)} >
          Cobrar
        </Button>
        <Button onClick={() => handleClear()}>
          Cancelar
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
